import { createFeatureSelector } from '@ngrx/store';

import { type FilesState } from '../files/files.reducer';
import { type NavigationState } from '../navigation/navigation.reducer';
import { type SettingsState } from '../settings/settings.reducer';

export interface UploaderState {
  files: FilesState;
  navigation: NavigationState;
  settings: SettingsState;
}

export const getUploaderState = createFeatureSelector<UploaderState>('uploader');
